import React, {useState, useEffect} from "react";
import NavBarElement from './NavBarElement'

import { useTheme } from '../../provider/themeProvider';

import SelectorElement from '../NavBar/SelectorElement';

import NavBarStyle from './NavBar.module.css';
import {useAppContext} from "../../provider/appProvider";

const NavBar = (props) => {
  const { countNotification, systemsAvailable, user, system, cameras } = useAppContext();

  const { darkMode } = useTheme();

  return (
    <nav className={NavBarStyle.nav}>
      <SelectorElement elementSelected={{
        image: 'https://cdn.codnum.fr/watch4safe/assets/images/favicon.svg',
        title: (system && system.name)
      }} elements={systemsAvailable.filter((theOtherSystem) => (system && theOtherSystem.id !== system.id))} position={0}/>
      <ul className={NavBarStyle.links}>
        <NavBarElement link={'/'} name={'Tableau de bord'}
                       icon={`https://cdn.codnum.fr/watch4safe/assets/images/home_${darkMode ? 'black' : 'white'}.svg`}/>
        <NavBarElement link={'/notifications'} name={'Notifications'}
                       icon={`https://cdn.codnum.fr/watch4safe/assets/images/notification_${darkMode ? 'black' : 'white'}.svg`}
                       count={countNotification()}/>
        <NavBarElement link={'/system'} name={'Système'}
                       icon={`https://cdn.codnum.fr/watch4safe/assets/images/setting_${darkMode ? 'black' : 'white'}.svg`}
                       children={[{name: 'Mon système', link: '/system'}, {
                         name: 'Paramètres',
                         link: '/system/settings'
                       }, {name: 'Abonnement', link: '/system/subscription'}, {
                         name: 'Utilisateurs',
                         link: '/system/users'
                       }]}/>
        <NavBarElement link={'/cameras'} name={'Caméras'}
                       icon={`https://cdn.codnum.fr/watch4safe/assets/images/camera_${darkMode ? 'black' : 'white'}.svg`}/>
        <NavBarElement link={'/sequences'} name={'Séquences'}
                       icon={`https://cdn.codnum.fr/watch4safe/assets/images/folder_${darkMode ? 'black' : 'white'}.svg`}/>
        {cameras.some(c => c.lapi_history) && (
          <NavBarElement link={'/anpr'} name={'Détections ANPR'}
                         icon={`https://cdn.codnum.fr/watch4safe/assets/images/plate_${darkMode ? 'black' : 'white'}.svg`}/>
        )}
      </ul>

      <div className={NavBarStyle.footer}>
        <SelectorElement elementSelected={{image: null, title: `${user ? user.first_name : ''} ${user ? user.last_name : ''}`, subTitle: ''}} elements={[{
          image: `https://cdn.codnum.fr/watch4safe/assets/images/account_${darkMode ? 'black' : 'white'}.svg`,
          icon: false,
          title: 'Mon compte',
          link: '/account'
        }, {
          image: `https://cdn.codnum.fr/watch4safe/assets/images/logout_${darkMode ? 'black' : 'white'}.svg`,
          icon: false,
          title: 'Me déconnecter',
          link: '/logout'
        }]} position={1} userAccount={{userID: user ? user.id : '', name: `${user ? user.last_name : ''} ${user ? user.first_name : ''}`}}/>
      </div>
      <div className={NavBarStyle.version}>
        <span>v{process.env.REACT_APP_VERSION}</span>
      </div>
    </nav>
  );
};

export default NavBar;
